<div class="app-sub-header">
    <div class="container">
        <h1 class="page-title red-color">Your Customer Overview</h1>
        <div
            class="sub-navigation flex justify-content-between align-items-center"
        >
            <eon-ui-button [routerLink]="['/collections']" icon="arrow_left"
                text="Back to Customer Overview" scheme="turquoise"></eon-ui-button>
        </div>
    </div>
</div>

<div class="main-wrapper">
    <div class="container no-padding">
        <p-tabs class="custom-no-bg" value="0">
            <p-tablist>
                <p-tab value="0">
                    <span>
                        <img src="assets/svg/live-view.svg" />
                        <span>Live View</span>
                    </span>
                </p-tab>
                <p-tab value="1">
                    <span>
                        <img src="assets/svg/dashboard.svg" />
                        <span>History</span>
                    </span>
                </p-tab>
            </p-tablist>
            <p-tabpanels>
                <p-tabpanel value="0">
                    <div class="grid">
                        @if (collectionDetails) {
                        <div class="col-12 entity-full-width">
                            <cc-collection-details-view [username]="username" [selectedSite]="selectedSite"
                                [collectionDetails]="collectionDetails" [pointsStatus]="entityStatus"></cc-collection-details-view>
                        </div>
                        }
                    </div>
                </p-tabpanel>
                <p-tabpanel value="1">
                    <div class="grid">
                        @if ((pointsObj | json) != '{}') {
                        <div class="col-12">
                            <cc-historical-data [pointsObj]="pointsObj"></cc-historical-data>
                        </div>
                        }
                    </div>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </div>
</div>

<p-confirmDialog #cd [style]="{width: '50vw'}" [breakpoints]="{'640px': '90vw'}" [style]="{width: '50vw'}">
    <ng-template pTemplate="footer">
        @if (userHasWritePermission$ | async; as userHasWritePermission) {
        <div class="flex justify-content-end">
            @if (!isOverrideResetOn || !userHasWritePermission) {
            <eon-ui-button size="small" scheme="turquoise" text="Close" (click)="cd.onReject()"></eon-ui-button>
            }
            @if (isOverrideResetOn && userHasWritePermission) {
            <eon-ui-button class="margin-right-1" size="small" scheme="turquoise" text="No" (click)="cd.onReject()"></eon-ui-button>
            }
            @if (isOverrideResetOn && userHasWritePermission) {
            <eon-ui-button size="small" scheme="turquoise" text="Yes" (click)="cd.onAccept()"></eon-ui-button>
            }
        </div>
        }
    </ng-template>
</p-confirmDialog>
